(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('fee-agenzia', {
            parent: 'entity',
            url: '/fee-agenzia?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.fee_agenzia.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/fee-agenzia/fee-agenzias.html',
                    controller: 'Fee_agenziaController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fee_agenzia');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('fee-agenzia-detail', {
            parent: 'fee-agenzia',
            url: '/fee-agenzia/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.fee_agenzia.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/fee-agenzia/fee-agenzia-detail.html',
                    controller: 'Fee_agenziaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fee_agenzia');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Fee_agenzia', function($stateParams, Fee_agenzia) {
                    return Fee_agenzia.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'fee-agenzia',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('fee-agenzia-detail.edit', {
            parent: 'fee-agenzia-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fee-agenzia/fee-agenzia-dialog.html',
                    controller: 'Fee_agenziaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Fee_agenzia', function(Fee_agenzia) {
                            return Fee_agenzia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('fee-agenzia.new', {
            parent: 'fee-agenzia',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fee-agenzia/fee-agenzia-dialog.html',
                    controller: 'Fee_agenziaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                valore: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('fee-agenzia', null, { reload: 'fee-agenzia' });
                }, function() {
                    $state.go('fee-agenzia');
                });
            }]
        })
        .state('fee-agenzia.edit', {
            parent: 'fee-agenzia',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fee-agenzia/fee-agenzia-dialog.html',
                    controller: 'Fee_agenziaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Fee_agenzia', function(Fee_agenzia) {
                            return Fee_agenzia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('fee-agenzia', null, { reload: 'fee-agenzia' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('fee-agenzia.delete', {
            parent: 'fee-agenzia',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fee-agenzia/fee-agenzia-delete-dialog.html',
                    controller: 'Fee_agenziaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Fee_agenzia', function(Fee_agenzia) {
                            return Fee_agenzia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('fee-agenzia', null, { reload: 'fee-agenzia' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
